/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmployeeFileWithRelations } from './employeeFileWithRelations';
import { UserWithRelations } from './userWithRelations';


/**
 * (tsType: EmployeeFileAccessLogWithRelations, schemaOptions: { includeRelations: true })
 */
export interface EmployeeFileAccessLogWithRelations { 
    id?: string;
    fileId: string;
    userId: number;
    action: string;
    /**
     * IP de origen. Completa solo con el permiso ViewClientIp; si no, recortada (189.203.x.x)
     */
    ipAddress?: string;
    userAgent?: string;
    createdOn?: string;
    file?: EmployeeFileWithRelations;
    user?: UserWithRelations;
}

